import * as B from '../block'
import {defaultConfig, migrate, MarkdownAdmin} from './admin'
import {ContentBlock} from '../AbstractBlock'

export const MarkdownBlock = B.blockWithInfo(
  {
    name: 'blurb',
    displayName: 'MarkdownBlock',
    title: 'Markdown',
    Admin: MarkdownAdmin,
    defaultConfig,
    migrate,
  },
  ({config: {justification, heading, message, position}}) => {
    const html = B.useMarkdown(message, {allowDangerousHtml: true}) || ''
    const content =
      message.trim() && html.trim() ? (
        <B.Html html={html} variant="dangerous" />
      ) : null

    return (
      <ContentBlock
        content={content}
        heading={heading}
        justification={justification}
        position={position}
      />
    )
  },
)
